import { useState, useRef, useEffect } from 'react';
import { ExternalLink } from 'lucide-react';

export default function LinkCell({ value, onChange, readOnly = false }) {
  const currentValue = typeof value === 'string' ? value : (value?.url || '');
  const [editing, setEditing] = useState(false);
  const [url, setUrl] = useState(currentValue);
  const inputRef = useRef(null);

  useEffect(() => { setUrl(currentValue); }, [currentValue]);
  useEffect(() => {
    if (editing && inputRef.current) { inputRef.current.focus(); inputRef.current.select(); }
  }, [editing]);

  const save = () => {
    const trimmed = url.trim();
    if (trimmed !== currentValue) onChange(trimmed || null);
    setEditing(false);
  };

  if (editing && !readOnly) {
    return (
      <input
        ref={inputRef}
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        onBlur={save}
        onKeyDown={(e) => {
          if (e.key === 'Enter') save();
          if (e.key === 'Escape') { setUrl(currentValue); setEditing(false); }
        }}
        placeholder="https://..."
        className="w-full h-full bg-transparent border-none outline-none text-sm text-text-primary px-2"
      />
    );
  }

  return (
    <div
      onClick={() => { if (!readOnly) setEditing(true); }}
      className={`w-full h-full px-2 text-sm min-h-[40px] flex items-center gap-1 justify-center transition-colors ${readOnly ? '' : 'cursor-pointer hover:bg-white/5'}`}
    >
      {currentValue ? (
        <>
          <span className="text-accent truncate text-xs">{currentValue.replace(/^https?:\/\//, '')}</span>
          <a
            href={currentValue}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="text-text-secondary hover:text-accent shrink-0"
          >
            <ExternalLink className="w-3 h-3" />
          </a>
        </>
      ) : (
        <span />
      )}
    </div>
  );
}
